function FTPModal(node) {
  if (!this instanceof FTPModal) return new FTPModal();

  const that = this;

  /**
   * @type Element
   */
  this.node = node;

  this.loadJson = function (json) {
    this.json = json;

    const xhr = new XMLHttpRequest();
    const that = this;
    xhr.open("GET", "content/ftp-modal.html", true);
    xhr.onreadystatechange = function () {
      if (this.readyState !== 4) return;
      if (this.status !== 200) return;

      const ftpModal = that.node.querySelector(".ftp-modal");
      ftpModal.insertAdjacentHTML("beforeend", this.responseText);

      const hostnameInput = ftpModal.querySelector("input[name=hostname]");
      const portInput = ftpModal.querySelector("input[name=port]");
      const usernameInput = ftpModal.querySelector("input[name=ftpusername]");
      const passwordInput = ftpModal.querySelector("input[name=ftppassword]");
      const directoryInput = ftpModal.querySelector("input[name=directory]");
      const sftpCheckbox = ftpModal.querySelector("input[name=sftp]");
      const ftpsCheckbox = ftpModal.querySelector("input[name=ftps]");

      that.ftpInputs = {
        hostnameInput: hostnameInput,
        portInput: portInput,
        usernameInput: usernameInput,
        passwordInput: passwordInput,
        directoryInput: directoryInput,
        sftpCheckbox: sftpCheckbox,
        ftpsCheckbox: ftpsCheckbox,
      };

      if (json.data.ftpConfig) {
        that.setValues(json.data.ftpConfig);
      }

      that.initHandlers(json);
    };
    xhr.send();
  };

  this.setValues = function (exportConfig) {
    if (exportConfig.hostname) {
      this.ftpInputs.hostnameInput.value = exportConfig.hostname;
    }

    if (exportConfig.port) {
      this.ftpInputs.portInput.value = exportConfig.port;
    }

    if (exportConfig.username) {
      this.ftpInputs.usernameInput.value = exportConfig.username;
    }

    if (exportConfig.password) {
      this.ftpInputs.passwordInput.value = exportConfig.password;
    }

    if (exportConfig.directory) {
      this.ftpInputs.directoryInput.value = exportConfig.directory;
    }

    this.ftpInputs.sftpCheckbox.checked = exportConfig.isSecure;
    this.ftpInputs.ftpsCheckbox.checked = exportConfig.isFTPS;
  };

  this.initHandlers = function () {
    const ftpButton = this.node.querySelector(".ftp-button");

    ftpButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const closeButton = this.node.querySelector(".ftp-modal .close-button");
    closeButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const cancelButton = this.node.querySelector(".ftp-modal .cancel-button");
    cancelButton.addEventListener("click", () => {
      this.toggleModal();
    });

    const saveButton = this.node.querySelector(".ftp-modal .save-button");
    saveButton.addEventListener("click", () => {
      this.saveConfig();
    });

    this.ftpInputs.ftpsCheckbox.addEventListener("click", () => {
      this.ftpInputs.sftpCheckbox.checked = false;
    });

    this.ftpInputs.sftpCheckbox.addEventListener("click", () => {
      this.ftpInputs.ftpsCheckbox.checked = false;
    });

    window.addEventListener("click", (event) => {
      this.windowOnClick(event);
    });
  };

  this.toggleModal = function () {
    const modal = this.node.querySelector(".ftp-modal");
    modal.classList.toggle("show-modal");
  };

  this.windowOnClick = function (event) {
    const modal = this.node.querySelector(".ftp-modal");
    if (event.target === modal) {
      this.toggleModal();
    }
  };

  this.saveConfig = function () {
    const ftpConfig = {
      hostname: this.ftpInputs.hostnameInput.value
        ? this.ftpInputs.hostnameInput.value
        : null,
      port: this.ftpInputs.portInput.value
        ? this.ftpInputs.portInput.value
        : null,
      username: this.ftpInputs.usernameInput.value
        ? this.ftpInputs.usernameInput.value
        : null,
      password: this.ftpInputs.passwordInput.value
        ? this.ftpInputs.passwordInput.value
        : null,
      directory: this.ftpInputs.directoryInput.value
        ? this.ftpInputs.directoryInput.value
        : null,
      isSecure: this.ftpInputs.sftpCheckbox.checked,
      isFTPS: this.ftpInputs.ftpsCheckbox.checked,
    };

    const that = this;
    const xhr = Network.openXHR(
      "POST",
      `${API_PATH}automaticExport/${this.json.data.id}/ftpConfig`
    );
    xhr.onerror = () => {
      snackbar.show({
        message:
          "Beim Speichern der FTP-Einstellungen ist ein Fehler aufgetreten.",
      });
    };
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        that.toggleModal();
        snackbar.show({
          message: "Die FTP-Einstellungen wurden erfolgreich gespeichert.",
        });
      }
    };

    xhr.send(JSON.stringify(ftpConfig));
  };
}
